var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CorporateNavigation", { attrs: { ActivePage: "resources" } }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _vm.isEditing
                      ? _c("SaveButton", {
                          attrs: { savingState: _vm.savingState },
                          on: {
                            saveChanges: function ($event) {
                              return _vm.handleSaveCommand()
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isEditing
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            staticStyle: { padding: "0.7em 2em" },
                            on: { click: _vm.cancelEditing },
                          },
                          [_vm._v(_vm._s(_vm.stopEditingLabel))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isEditing
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            staticStyle: { padding: "0.7em 2em" },
                            on: { click: _vm.startEditing },
                          },
                          [_vm._v("Edit unit costs")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "alert alert-info", attrs: { role: "alert" } },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.rm?.FiscalYearRangeLabel) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.isEditing
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        {
                          staticClass: "alert alert-warning",
                          attrs: { role: "alert" },
                        },
                        [
                          _vm._v(
                            "\n                Warning: Formula entered here will save as values.\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("EditableValueSeriesSheet", {
                        ref: "sheet",
                        attrs: {
                          propTitle: _vm.title,
                          propSeries: _vm.inputSeries,
                          propColumns: _vm.rm.Columns,
                        },
                        on: { dataChange: _vm.onDataChange },
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("div", { staticClass: "toolbar" }, [
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "btn-group",
                              attrs: { role: "group" },
                            },
                            [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "sanitizedHref",
                                      rawName: "v-sanitizedHref",
                                      value: `/#/enterprise/resources/${_vm.workspaceId}/${_vm.strategyId}`,
                                      expression:
                                        "`/#/enterprise/resources/${workspaceId}/${strategyId}`",
                                    },
                                  ],
                                  staticClass: "btn btn-outline-secondary",
                                },
                                [
                                  _vm._v(
                                    "\n                            Resources\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "btn btn-secondary disabled" },
                                [
                                  _vm._v(
                                    "\n                            Unit costs\n                        "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div"),
                      ]),
                      _vm._v(" "),
                      _c("ValueSeriesTable", {
                        attrs: {
                          propTitle: _vm.title,
                          propSeries: _vm.rm.Series,
                          propColumns: _vm.rm.Columns,
                        },
                      }),
                    ],
                    1
                  ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Unit costs")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }